module.exports = __webpack_public_path__ + "img/is-vpnbook-safe-to-use.06c6abc3.png";